import { AccountTypeBadge, normalizeAccountType, type AccountType } from "./AccountTypeBadge";

// Who posted the listing, shown next to the price on every card so buyers can
// tell an owner from an agency at a glance (the API sends it as user.type).

export type OwnerKind = AccountType;

/** Owner type + verified tick from any listing shape the lists pass around
 * (raw API `user`, mapped `seller`, favourites nested under `property`). */
export function listingOwner(listing: any): { kind: OwnerKind; verified: boolean } | null {
  // Favourites wrap the listing: `listing.user` there is the viewer who saved
  // it, not the seller — so a nested `property` always wins.
  const base = listing?.property ?? listing;
  const u = base?.user ?? base?.seller;
  const kind = normalizeAccountType(u?.type);
  if (!kind) return null;
  return { kind, verified: Boolean(u?.is_tick) };
}

export function OwnerBadge({
  listing,
  size = "md",
  className = "",
}: {
  listing: any;
  size?: "sm" | "md";
  className?: string;
}) {
  const owner = listingOwner(listing);
  if (!owner) return null;
  return (
    <AccountTypeBadge type={owner.kind} verified={owner.verified} size={size === "sm" ? "xs" : "sm"} className={className} />
  );
}
